import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { CommonUploadService } from './common-upload.service';
import { SocketLog } from './socket.service';
import { EventLayer, TextFileSeparator, FileType, FeatureLayer } from './common-upload.service';
import { FP } from './../../assets/TS/FileProcess';

@Injectable()
export class LbeUploadService {

	// Event Data
	public eventColumnSeparatorVal: string;
	public eventFileType: FileType;
	public eventLayersBS: BehaviorSubject<EventLayer[]> = new BehaviorSubject([]);
	public eventFilesRaw: FP.GroupedFiles = null;
	// Arnold Data
	public arnoldLayersBS: BehaviorSubject<FeatureLayer[]> = new BehaviorSubject([]);
	public arnoldFilesRaw: FP.GroupedFiles = null;
	public arnoldLrsSpec: {
		name: string;
		desc: string;
		meas_uom: string;
		meas_precision: number;
	};
	//
	public uploadingLogs: BehaviorSubject<{[processId: string]: SocketLog}> = new BehaviorSubject({});
	constructor(
		private cUploadService: CommonUploadService
	) {
		this.eventFilesRaw = this.cUploadService.initEventFilesRaw();
		this.arnoldFilesRaw = this.cUploadService.initArnoldFilesRaw();
	}

}



// WEBPACK FOOTER //
// ./src/app/common-services/lbe-upload.service.ts